import { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { getTotalNxacList } from "src/service/pay";
import { localStrings } from "src/utils/localization";
import "./UpcList.style.scss";
import { customAlert } from "src/utils/alert";
import { UseFormSetValue } from "react-hook-form";
import { useGetTotalNxacList } from "src/hooks/api/nxac/useGetTotalNxacList";
import { TotalNxacType } from "src/service/types/pay.type";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
interface IUpcListProps {
  productInfo: any;
  setValue?: UseFormSetValue<any>;
}
const UpcList = ({ productInfo, setValue }: IUpcListProps) => {
  const { t } = useTranslation();
  const [applicationList, setApplicationList] = useState<any>([]);
  const [showExtDetail, setShowExtDetail] = useState<boolean>(false);
  const [showExtDetailUid, setShowExtDetailUid] = useState<string>("");
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  // const { register, setValue, getValues, formState, handleSubmit } =
  //   useCommonForm();
  useEffect(() => {
    getTotalNxacList().then((result) => {
      setApplicationList(result);
    });
  }, []);
  const { isLoadingNxacList, nxacList } = useGetTotalNxacList({});
  useEffect(() => {
    if (setValue) {
      let filterResult: any;
      if (nxacList !== undefined && selectAppList !== undefined) {
        const tempNxacList: TotalNxacType[] = [...nxacList];
        const filterNxacList = tempNxacList.filter((data: any) =>
          selectAppList?.includes(data.nxacAppUid)
        );
        if (filterNxacList) {
          filterResult = filterNxacList?.map((data) => {
            const { applicationName, nxacAppUid } = data;
            return {
              id: nxacAppUid,
              name: applicationName,
            };
          });
          // console.log("filterResult", filterResult);
        }
      }
      setValue("issueAppList", filterResult);
      // console.log("selectAppList", selectAppList);
      // console.log("issueAppList", filterResult);
    }
    // console.log("selectAppList", selectAppList);
    // if(selectAppListRef)
    //   selectAppListRef.current?.value = [...selectAppList]
  }, [selectAppList]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "selectAppList") {
      // console.log("selectAppList", e.target.value);
      if (selectAppList.indexOf(e.target.value as never) !== -1) {
        setSelectAppList((prev) => prev.filter((el) => el !== e.target.value));
      } else {
        setSelectAppList((prev) => {
          if (
            prev.length === productInfo.upcCnt &&
            productInfo.name !== "Premium"
          ) {
            // alert(
            //   `${productInfo.name} 요금제에서는 ${productInfo.upcCnt}개까지만 선택할 수 있습니다.\n더 많은 애플리케이션 지원이 필요하다면\nPremium 요금제를 신청해 주세요.`
            // );
            // notifyWarning("asd");
            customAlert({
              html: `${t("admin.upc.site.upcSelectLimit")}`,
            });
            // alertTest(
            //   `더 많은 애플리케이션을 선택하려면 Wrapsody eCo Cloud 웹사이트(
            //     <a href="https://wrapsodyeco.com/kr/inquiry">
            //       wrapsodyeco.com/kr/inquiry
            //     </a>
            //   )에서 문의를 남겨주세요.`
            // );
            return prev;
          } else return prev.concat(e.target.value as never);
        });
      }
    }
  };
  const openExtDetailModal = (e: any, uid: any) => {
    e.preventDefault();

    setShowExtDetail(true);
    setShowExtDetailUid(uid);
  };
  const hideExtDetailModal = () => {
    setShowExtDetail(false);
  };
  const { lang } = useRouter();
  return (
    <>
      {productInfo?.upcCnt > 0 && (
        <div className="mg mb-20">
          <span className="form-item-title">{t("cashStatus.chooseApp")}</span>
          <div className="mg mt-10 selectApplication">
            {applicationList.length > 0 &&
              applicationList.map((item: any, index: number) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignContent: "center",
                    }}
                    className="mg mt-10 mb-10"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignContent: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <input
                        type="checkbox"
                        name="selectAppList"
                        id={"selectAppList_" + item.nxacAppUid}
                        value={item.nxacAppUid}
                        checked={selectAppList.indexOf(item.nxacAppUid) !== -1}
                        onChange={handleChange}
                        // htmlFor={"selectAppList_" + item.nxacAppUid}
                      />
                      <label
                        className="inputArea-label"
                        htmlFor={"selectAppList_" + item.nxacAppUid}
                      ></label>
                      <span
                        className={`form-input-label app textEllipsis ${
                          lang === "ko" ? "" : "mg ml-24"
                        }`}
                        title={item.applicationName}
                      >
                        {item.applicationName}
                      </span>
                    </div>

                    <button
                      onClick={(e) => openExtDetailModal(e, item.nxacAppUid)}
                      // className="btn btn-green btn-36 width w-66 mg ml-auto "
                      className="btn btn-green btn-sm mg ml-auto "
                    >
                      {t("common.more")}
                    </button>
                  </div>
                );
              })}

            {selectAppList && (
              <input
                style={{ display: "none" }}
                value={selectAppList}
                // {...register("issueAppList", {
                //   value: selectAppList,
                // })}
                // value={selectAppList}
              />
            )}
          </div>
          <hr />
        </div>
      )}
      {showExtDetail && (
        <Modal
          show={showExtDetail}
          style={{ opacity: 1 }}
          className="applicationModal"
          animation={false}
          onHide={() => hideExtDetailModal()}
        >
          <Modal.Dialog style={{ margin: 0, width: 840 }}>
            <Modal.Header>
              <div className="header">
                <h3>{t("admin.upc.site.applicationModal")}</h3>
                <div className="exit">
                  <a onClick={() => hideExtDetailModal()}>
                    <i className="icon_cancel" />
                  </a>
                </div>
              </div>
            </Modal.Header>
            <Modal.Body style={{ width: "100%" }}>
              {/* {applicationList.map(item => ( */}

              {applicationList.map((item: any) =>
                item.nxacAppUid === showExtDetailUid ? (
                  <table>
                    <colgroup>
                      <col width="10%" />
                      <col width="20%" />
                      <col width="70%" />
                    </colgroup>
                    <tr>
                      <td colSpan={2}>
                        {t("admin.upc.site.applicationModal")}
                      </td>
                      <td
                        colSpan={2}
                        className="title"
                        title={item.applicationName}
                      >
                        {item.applicationName}
                      </td>
                    </tr>
                    <tr>
                      <td />
                      <td>{t("admin.upc.site.process")}</td>
                      <td>{t("admin.upc.site.extension")}</td>
                    </tr>
                    {item.processList.map((item1: any) => (
                      <tr>
                        <td />
                        <td>
                          <span
                            className="processName"
                            title={item1.processName}
                          >
                            {item1.processName}
                          </span>
                        </td>
                        <td>
                          <span className="upc" title={item1.nxacExt}>
                            {item1.nxacExt}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </table>
                ) : (
                  ""
                )
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-green"
                onClick={() => hideExtDetailModal()}
              >
                {t("common.okBtn")}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal>
      )}
    </>
  );
};
export default UpcList;
